import { gameId } from '../helpers/socketio';
import { game } from './chess';
import { PlayerRouteId, gameMoveBlock } from './onDrop';

declare let $: any;

export function onMouseoverSquare(square: any, piece: any) {
  if (window.location.pathname === `/historyboard/${PlayerRouteId}`) {
    return;
  }
  if (window.location.pathname === `/puzzle/complatedpuzzle`) {
    return;
  }
  if(window.location.pathname !== `/puzzle` ){
    if (gameMoveBlock == 'completed' || gameMoveBlock == 'resign' || gameMoveBlock == 'draw' ||  gameMoveBlock == 'timeout' || gameMoveBlock == 'checkmate') {
      return;
    }
  }
  // get list of possible moves for this square
  var moves = game.moves({
    square: square,
    verbose: true,
  });

  // exit if there are no moves available for this square
  if (moves.length === 0) return;

  // add dots to the possible squares for this piece
  for (var i = 0; i < moves.length; i++) {
    addDots(moves[i].to);
  }
}

function addDots(square: any) {
  var $square = $('#hijk .square-' + square);
  $square.append('<div class="dot"></div>');
}

export function onMouseoutSquare(square: any, piece: any) {
  removeDots();
}

export function removeDots() {
  $('#hijk .dot').remove();
}
